import { render } from "./AboutTeamSection.vue?vue&type=template&id=041bc88c&scoped=true"
import script from "./AboutTeamSection.vue?vue&type=script&lang=js"
export * from "./AboutTeamSection.vue?vue&type=script&lang=js"

import "./AboutTeamSection.vue?vue&type=style&index=0&id=041bc88c&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041bc88c"]])

export default __exports__